<app-lead-modal
  [isOpen]="isLeadModalOpen"
  [leadId]="leadSelecionadoId"
  (closeModal)="fecharLeadModal()">
</app-lead-modal>

<app-confirm-dialog
  [isOpen]="isConfirmDialogOpen"
  [title]="'Kali ERP: Confirmacao'"
  [message]="'Deseja realmente remover este lead?'"
  [cancelLabel]="'Nao'"
  [confirmLabel]="'Sim, remover'"
  (cancelled)="fecharDialogRemocaoLead()"
  (confirmed)="confirmarRemocaoLead()">
</app-confirm-dialog>

<div class="leads-card">

  <!-- Header -->
  <div class="leads-header">
    <div class="leads-header-meta">
      <span class="leads-eyebrow">CRM</span>
      <h2 class="leads-title">Leads Recentes</h2>
      <p class="leads-subtitle">Últimos 7 dias · clique em Converter para gerar um orçamento</p>
    </div>
    <button type="button" class="btn-refresh" (click)="classificarEAtualizarLeads()" [disabled]="isLoading">
      Classificar e Atualizar
    </button>
  </div>

  <!-- Search -->
  <div class="leads-search">
    <div class="search-wrapper">
      <i class="bi bi-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        [value]="termoBuscaLeads"
        (input)="atualizarBuscaLeads($any($event.target).value)"
        placeholder="Pesquisar por nome do lead..." />
      @if (termoBuscaLeads) {
        <button class="search-clear" (click)="atualizarBuscaLeads('')" title="Limpar">
          <i class="bi bi-x"></i>
        </button>
      }
    </div>
  </div>

  <!-- Loading -->
  @if (isLoading) {
    <div class="state-box">
      <div class="spinner-border text-primary" role="status"></div>
      <span>Carregando leads...</span>
    </div>
  }

  <!-- Error -->
  @if (hasError && !isLoading) {
    <div class="state-box state-error">
      <i class="bi bi-exclamation-triangle"></i>
      <span>Não foi possível carregar os leads.</span>
      <button class="btn-retry" (click)="loadLeads()">Tentar novamente</button>
    </div>
  }

  <!-- Table -->
  @if (!isLoading && !hasError) {
    <div class="table-wrapper">
      <table class="leads-table">
        <thead>
          <tr>
            <th class="col-id hide-xs">ID</th>
            <th class="col-nome">Nome</th>
            <th class="col-telefone">Telefone</th>
            <th class="col-canal hide-sm">Canal</th>
            <th class="col-score hide-sm">Score</th>
            <th class="col-data hide-sm">Data</th>
            <th class="col-acoes">Ações</th>
          </tr>
        </thead>
        <tbody>
          @for (lead of leadsPaginados; track lead.id) {
            <tr>
              <td class="hide-xs text-muted">{{ lead.id }}</td>
              <td class="col-nome-cell">
                <span class="lead-nome">{{ lead.nome }}</span>
              </td>
              <td>{{ lead.telefone | mask: '(00) 00000-0000' }}</td>
              <td class="hide-sm">
                <span class="canal-badge">{{ lead.canal }}</span>
              </td>
              <td class="col-scoretext-muted">{{ lead.score }}</td>
              <td class="hide-sm text-muted">{{ lead.dataRegistro | date: 'dd/MM/yy HH:mm' }}</td>
              
              
              <td class="col-acoes-cell">
                <button type="button" class="btn-action btn-view" (click)="visualizarLead(lead)" title="Visualizar lead">
                  <i class="bi bi-eye"></i>
                </button>
                <button type="button" class="btn-action btn-convert" (click)="efetuarOrcamento(lead)" title="Converter em orçamento">
                  <i class="bi bi-file-earmark-plus"></i>
                  <span class="btn-label">Converter</span>
                </button>
                <button type="button" class="btn-action btn-remove" (click)="removerLead(lead)" title="Remover lead">
                  <i class="bi bi-trash3"></i>
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="6" class="empty-row">
                <i class="bi bi-inbox"></i>
                <span>Nenhum lead encontrado.</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    @if (totalPagesLeads > 1) {
      <nav class="leads-pagination" aria-label="Navegação de páginas">
        <button class="page-btn" [disabled]="currentPage === 0" (click)="setPage(0)" title="Primeira">
          <i class="bi bi-chevron-double-left"></i>
        </button>
        <button class="page-btn" [disabled]="currentPage === 0" (click)="setPage(currentPage - 1)" title="Anterior">
          <i class="bi bi-chevron-left"></i>
        </button>

        <div class="page-numbers">
          @for (p of pageRange; track p) {
            <button class="page-btn page-num" [class.active]="p === currentPage" (click)="setPage(p)">
              {{ p + 1 }}
            </button>
          }
        </div>

        <button class="page-btn" [disabled]="currentPage === totalPagesLeads - 1" (click)="setPage(currentPage + 1)" title="Próxima">
          <i class="bi bi-chevron-right"></i>
        </button>
        <button class="page-btn" [disabled]="currentPage === totalPagesLeads - 1" (click)="setPage(totalPagesLeads - 1)" title="Última">
          <i class="bi bi-chevron-double-right"></i>
        </button>

        <span class="page-info">
          {{ currentPage + 1 }} / {{ totalPagesLeads }}
          <span class="hide-xs">· {{ leadsFiltrados.length }} leads</span>
        </span>
      </nav>
    }
  }

</div>
